module.exports = __webpack_public_path__ + "static/media/fav.9ba7505b.svg";